export default ($http) => ({
  getCalendarByDate ({ day = '', option }) {
    return $http.get(`my-dashboard-calendar-day${day ? '/' : ''}${day}`, { query: { option } })
  },
  getCalendarByMonth ({ month }) {
    return $http.get(`my-dashboard-calendar-month/${month}`)
  },
  getDashboardCourses () {
    return $http.get('my-dashboard-courses')
  },
  getAllCourses (query) {
    return $http.post('my-dashboard-courses-all', { body: query })
  },
  addCourseToDashboard (id) {
    return $http.post('my-dashboard-courses', { body: { id } })
  },
  deleteCourseFromDashboard (id) {
    return $http.delete(`my-dashboard-courses/${id}`)
  },
  sortDashboardCourses (courses) {
    return $http.put('my-dashboard-courses/sort', { body: { courses } })
  },
  getDashboardLinks () {
    return $http.get('my-dashboard-links')
  },
  sortDashboardLinks (links) {
    return $http.put('my-dashboard-links-sort', { body: { links } })
  },
  updateDashboardLink (id, payload) {
    return $http.put(`my-dashboard-links/${id}`, { body: payload })
  },
  getTodayCurriculumViewOption () {
    return $http.get('my-dashboard-curriculum-view-option')
  },
  updateTodayCurriculumViewOption (option = 'all') {
    return $http.put('my-dashboard-curriculum-view-option', { body: { option }, hasNotification: true })
  }
})
